let Base64 = require('js-base64').Base64
import CryptoJS from 'crypto-js'

export function base64Encode(str) {
  return Base64.encode(str);
}

/**
 * 加密处理
 */
 export const encryption = (params) => {
  let {
    data,
    type,
    param,
    encryption
  } = params
  const result = JSON.parse(JSON.stringify(data))
  if (type === 'Base64') {
    param.forEach(ele => {
      result[ele] = btoa(result[ele])
    })
  } else {
    param.forEach(ele => {
      var data = result[ele]
      encryption = CryptoJS.enc.Latin1.parse(encryption)
      var iv = encryption
      // 加密
      var encrypted = CryptoJS.AES.encrypt(
        data,
        encryption,
        { iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.ZeroPadding
        })
      result[ele] = encrypted.toString()
    })
  }
  return result
}